import { render, staticRenderFns } from "./wrongQuestion.vue?vue&type=template&id=0daa4c88&scoped=true"
import script from "./wrongQuestion.vue?vue&type=script&lang=js"
export * from "./wrongQuestion.vue?vue&type=script&lang=js"
import style0 from "./wrongQuestion.vue?vue&type=style&index=0&id=0daa4c88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daa4c88",
  null
  
)

export default component.exports